import axios from 'axios'

const API_URL = process.env.REACT_APP_BASE_API_URL
const GET_FOUNDER_PROMOTER = `${API_URL}/stakeholders/founders-promoters`
const GET_GOVT_ID_TYPES = `${API_URL}/ref-data?group=govtIssuedIdTypes`
const CREATE_FOUNDER_PROMOTER = `${API_URL}/stakeholders/founders-promoters`
const EXPORT_FOUNDER_PROMOTER = `${API_URL}/stakeholders/founders-promoters/csv/export`
const GET_DROPDOWN_DATA=`${API_URL}/stakeholders/individuals`
const GET_INDIVIDUAL_STAKEHOLDER_DATA=`${API_URL}/stakeholders/individual`
const CREATE_PROFESSIONAL_EXPERIENCES=`${API_URL}/stakeholders/founders-promoters/experience`

export const getFounderPromoter = (
  companyId: number,
  page: number,
  pageSize: number,
  type?: string,
  sortBy?: string
) => {
  return axios.get(
    `${GET_FOUNDER_PROMOTER}?page=${page}&pageSize=${pageSize}${type ? `&type=${type}` : ''}${
      sortBy ? `&sortBy=${sortBy}` : ''
    }`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getFounderPromoterDetails = (founderPromoterId: string, companyId: number) => {
  return axios.get(`${GET_FOUNDER_PROMOTER}/${founderPromoterId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getIndividualStakeholders = (founderPromoterId: string, companyId: number) => {
  return axios.get(`${GET_INDIVIDUAL_STAKEHOLDER_DATA}/${founderPromoterId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}


export const getDropDownData = (companyId: number) => {
  return axios.get(`${GET_DROPDOWN_DATA}?all=true`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getGovtIdTypes = (type: string, companyId: number) => {
  return axios.get(`${GET_GOVT_ID_TYPES}&type=${type}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const createFounderPromoter = (payload: any, companyId: number) => {
  return axios.post(`${CREATE_FOUNDER_PROMOTER}`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const createProfessionalExperiences = (payload: any, companyId: number) => {
  return axios.post(`${CREATE_PROFESSIONAL_EXPERIENCES}`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const updateProfessionalExperiences = (payload: any, companyId: number,id:number) => {
  return axios.post(`${CREATE_PROFESSIONAL_EXPERIENCES}/${id}`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const updateFounderPromoter = (
  payload: any,
  companyId: number,
  founderPromoterId: string
) => {
  return axios.post(`${CREATE_FOUNDER_PROMOTER}/${founderPromoterId}`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const exportFoundersPromoters = (companyId: number) => {
  return axios.get(`${EXPORT_FOUNDER_PROMOTER}`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const deleteFounderPromoter = (founderPromoterId: string, companyId: number) => {
  return axios.delete(`${CREATE_FOUNDER_PROMOTER}/${founderPromoterId}`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getFoundersPromotersStatistics = (companyId: number) => {
  return axios.get(`${GET_FOUNDER_PROMOTER}/statistics`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const importFoundersPromoters = (data: any, companyId: number) => {
  return axios.post(`${CREATE_FOUNDER_PROMOTER}/csv/import`, {foundersPromoters: data}, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const downloadDocument = (name:string ,companyId: number) => {
  const key = encodeURIComponent(name)
  return axios.get(`${API_URL}/file/signed/${key}`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}
